// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","primary":"#56CCF2","primaryLight":"#ABEAFF","secondary":"#33C370","secondaryLight":"#7FE7AB","textDefault":"#808080"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Datepicker/Datepicker.css
// module id = 1120
// module chunks = 0